export enum WorkOrderType {
  UNKNOWN,
  REDEEM_CODE_REFUND, // 兑换码退款
  NO_PURCHASE_ORDER_REFUND, // 无订单退款
  REFUND_FAIL, // 退款失败
  REFUND_QUERY_FAIL, // 退款查询失败
}

export enum WorkOrderPriority {
  LOW,
  NORMAL,
  HIGH,
  URGENT,
}

export enum WorkOrderEventSource {
  NONE,
  INVOICE, // REDEEM_CODE_REFUND
  ORDER, // NO_PURCHASE_ORDER_REFUND
}

export enum WorkOrderStatus {
  CREATED, // 创建
  PROCESSING, // 处理中
  DONE, // 完结
  REOPENED, // 重新打开
}

export interface WorkOrderRefundMetadata {
  amount: string;
  reason: string;
  userId: number;
}

export interface WorkOrderHistory {
  id: number;
  description: string;
  performedById: number;
  workOrderId: number;
  workOrderStatus: WorkOrderStatus;
}

export interface WorkOrder {
  id: number;
  title: string;
  eventId: number;
  eventSource: number;
  histories: WorkOrderHistory[];
  metadata: WorkOrderRefundMetadata;
  status: WorkOrderStatus;
  type: WorkOrderType;
  priority: WorkOrderPriority;
}



// WEBPACK FOOTER //
// ./src/screens/workOrder/type.tsx